import React from 'react';
import './badge.css';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function TypeGlyph({ size = 15, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      style={{ display: 'block' }}
      {...stroke}
    >
      {children}
    </svg>
  );
}

/** Generic mission mark — same white quest marker as flow available missions. */
export function GenericMissionIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className="quest-marker"
      style={{ display: 'block' }}
    >
      <path d="M12 3 L14.5 15 L12 16 L9.5 15 Z" fill="white" />
      <path d="M12 18 L14 20 L12 22 L10 20 Z" fill="white" />
    </svg>
  );
}

/** Checkered start flag — overlays the mission icon for "it's time to start". */
export function StartFlagOverlay({ size = 12 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      aria-hidden
      style={{ display: 'block' }}
    >
      <line x1="2.2" y1="1.5" x2="2.2" y2="14.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <rect x="3" y="1.8" width="11" height="8" rx="0.6" fill="#f4f4f5" />
      <path fill="#18181b" d="M3 1.8h2.75v2.65H3zM8.5 1.8H11.25v2.65H8.5zM5.75 4.45H8.5v2.65H5.75zM11.25 4.45H14v2.65h-2.75zM3 7.1h2.75v2.7H3zM8.5 7.1H11.25v2.7H8.5z" />
    </svg>
  );
}

/**
 * Time-to-start badge: the mission's own icon (or the generic mark),
 * with a start flag superimposed. Pass `base` for a custom mission icon.
 */
export function MissionAvailableIcon({ size = 22, base = null }) {
  return (
    <span className="notif-mission-start" style={{ width: size, height: size }}>
      <span className="notif-mission-start__base">
        {base || <GenericMissionIcon size={size} />}
      </span>
      <span className="notif-mission-start__flag" aria-hidden>
        <StartFlagOverlay size={13} />
      </span>
    </span>
  );
}

/** User asked to be pinged at a date/time. */
export function ReminderAtTimeIcon({ size = 15 }) {
  return (
    <TypeGlyph size={size}>
      <circle cx="12" cy="13" r="8" />
      <polyline points="12 9 12 13 15 15" />
      <path d="M5 3 L8 6" />
      <path d="M19 3 L16 6" />
    </TypeGlyph>
  );
}

/** User asked to be pinged when the mission becomes available. */
export function ReminderWhenAvailableIcon({ size = 15 }) {
  return (
    <TypeGlyph size={size}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M7 11V8a5 5 0 0 1 9.9-1" />
    </TypeGlyph>
  );
}

/** A wait-for card is asking whether the reply arrived. */
export function WaitForIcon({ size = 15 }) {
  return (
    <TypeGlyph size={size}>
      <path d="M6 2h12" />
      <path d="M6 22h12" />
      <path d="M7 2c0 5 5 7 5 10s-5 5-5 10" />
      <path d="M17 2c0 5-5 7-5 10s5 5 5 10" />
    </TypeGlyph>
  );
}

/** Someone invited this account into a brain. */
export function WorkspaceInviteIcon({ size = 15 }) {
  return (
    <TypeGlyph size={size}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <line x1="19" y1="8" x2="19" y2="14" />
      <line x1="22" y1="11" x2="16" y2="11" />
    </TypeGlyph>
  );
}

/** Unknown / legacy type. */
export function NotificationFallbackIcon({ size = 15 }) {
  return (
    <TypeGlyph size={size}>
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    </TypeGlyph>
  );
}
